import styles from './CartHeader.module.scss';

import { FC, memo } from 'react';
import { CART_TEST_IDS } from './Cart.consts';
import { useCart } from 'hooks/context/cart';
import { useGiftCardCart } from 'hooks/context/giftCardCart';
import { useMerchantState } from 'hooks/context/MerchantState';
import { CartServicesDineIn } from 'components/CartServicesDineIn';
import { CartServices } from 'components/CartServices';

export const CartHeader: FC<{ onClick?: () => void }> = memo(function CartHeader({ onClick, ...props }) {
  const { itemCount: cartItemCount } = useCart();
  const { itemCount: giftCardCount } = useGiftCardCart();
  const { showDineInState } = useMerchantState();
  const isOnlyDigitalCart = cartItemCount === 0 && giftCardCount > 0;

  if (isOnlyDigitalCart) return null;

  if (showDineInState) {
    return (
      <div className={styles.dropdownWrapper} data-testid={CART_TEST_IDS.header} {...props}>
        <CartServicesDineIn />
      </div>
    );
  }

  return (
    <div className={styles.dropdownWrapper} data-testid={CART_TEST_IDS.header} {...props}>
      <CartServices onClick={onClick} />
    </div>
  );
});
